// Entrega al navegador el CSV del historial y arma su nombre: el API responde `text/csv` sin nombre.
import { mxDay } from '@/lib/dateHelpers';

export function salePromotionLogFilename(promotionId: string | undefined, now: Date): string {
    const day = mxDay(now.toISOString());
    return promotionId
        ? `historial-promo-venta-${promotionId}-${day}.csv`
        : `historial-promos-venta-${day}.csv`;
}

export function downloadCsv({ blob, filename }: { blob: Blob; filename: string }): void {
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    // Diferido: Firefox y Safari cancelan la descarga si el blob se libera antes de leerlo.
    setTimeout(() => {
        URL.revokeObjectURL(objectUrl);
    }, 0);
}
